import { createAsyncThunk, EnhancedStore } from '@reduxjs/toolkit';
import { newSearch } from '../store/uiSlice';
import { AppDispatch } from '../store/store';
import store from '../store/store';
import { openTabvana } from '../main/openTabvana';
import { logger } from '../utils/logger';

export function registerCommandListeners(store: EnhancedStore) {
  const browser = chrome;

  browser.commands.onCommand.addListener((command) => {
    logger.info(`[Command] ${command}`);

    const dispatch: AppDispatch = store.dispatch;

    if (command === 'global_search') {
      dispatch(openTabvanaAsync());
      dispatch(newSearch());
    }
  });
}

const openTabvanaAsync = createAsyncThunk('ui/openTabvana', async () => {
  await openTabvana();
});
